<button [type]="type" [class]="'btn btn-' + variant + ' ' + extraClasses" [disabled]="loading || disabled">
  <div *ngIf="loading; else defaultContent">
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    {{ loadingLabel || 'Cargando' }}...
  </div>
  <ng-template #defaultContent>
    <ng-content></ng-content>
  </ng-template>
</button>
